var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 82,
    r: 82,
    fill: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14777_113493",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 164,
    height: 164
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 82,
    r: 82,
    fill: "#F4F4F4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14777_113493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93 108H82V164H93V108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 105H82V139H93V105Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.349 58.5983C96.6996 58.5983 88.0645 67.2334 88.0645 77.883V107.896H126.633V77.883C126.633 67.2334 117.999 58.5983 107.349 58.5983Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7656 107.896H107.35V58.5983H67.7656V107.896Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7661 58.5983C57.1154 58.5983 48.4824 67.2334 48.4824 77.883V107.896H87.0509V77.883C87.0509 67.2334 78.4179 58.5983 67.7661 58.5983Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7655 61.6438C58.745 61.6438 51.4316 68.9582 51.4316 77.9787V105.288H84.1015V77.9787C84.1015 68.9582 76.7871 61.6438 67.7655 61.6438Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 79H126V76H86V79Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5449 49.9255V60.1865L105.389 55.0544L91.5449 49.9255Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3713 48.3048H91.5449V83.249H94.3713V48.3048Z",
    fill: "#E9EAE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2002 83.9599C97.2002 86.2418 95.3503 88.0918 93.0683 88.0918C90.7875 88.0918 88.9375 86.2418 88.9375 83.9599C88.9375 81.678 90.7875 79.828 93.0683 79.828C95.3503 79.828 97.2002 81.678 97.2002 83.9599Z",
    fill: "#FFFBF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0319 83.9659C95.0319 85.0517 94.1519 85.9307 93.0672 85.9307C91.9825 85.9307 91.1035 85.0517 91.1035 83.9659C91.1035 82.8813 91.9825 82.0012 93.0672 82.0012C94.1519 82.0012 95.0319 82.8813 95.0319 83.9659Z",
    fill: "#BABBBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 103H126V93H108V103Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 103H108V93H87V103Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 91H126V89H108V91Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 91H108V89H87V91Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9453 98.0591L72.4013 84.1652L31.7501 103.534L25.0863 114.02L23.9453 98.0591Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2176 113.447L31.75 103.535L72.4012 84.1656L46.2176 113.447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.004 106.451L25.0859 114.02L31.7498 103.534L36.004 106.451Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9458 98.0596L15 91.5429L72.4018 84.1657L23.9458 98.0596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.699 102.629L98.8008 90.9023L133.111 107.251L138.736 116.099L139.699 102.629Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.899 115.616L133.111 107.251L98.8008 90.9016L120.899 115.616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.518 109.712L138.735 116.099L133.109 107.251L129.518 109.712Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.699 102.629L147.249 97.1287L98.8008 90.9022L139.699 102.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1128 33.9536L72.6074 39.7504L94.1708 38.1018L99.4524 40.874L96.1128 33.9536Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5131 45.6885L94.1708 38.1012L72.6074 39.7499L90.5131 45.6885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0938 40.3328L99.4513 40.874L94.1698 38.1018L93.0938 40.3328Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1128 33.9542L98.2811 29.1024L72.6074 39.751L96.1128 33.9542Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyForm);
export default __webpack_public_path__ + "static/media/emptyForm.472be0099c1e9c4761cdc4a0538a948e.svg";
export { ForwardRef as ReactComponent };